import DetailedViewHeader from './DetailedViewHeader'

export default DetailedViewHeader
